/* eslint-disable react-hooks/exhaustive-deps */
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { DatePickerComponent } from "@unisearch/common/form";
import { selectStyles, swalError } from "@unisearch/helpers";
import { evaluationAtom } from "@_recoil/_state";
import { Field } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useRecoilState, useRecoilValue } from "recoil";
import styles from "./evaluation_education.module.scss";
import API from "@unisearch/helpers/api";
const EvaluationEducation = () => {
  // const evaluationActions = useEvaluationActions();

  const { heightEducationLevel, is_loading } = useRecoilValue(evaluationAtom);

  const [{ highestEducation }, setHighestEducation] = useRecoilState(
    evaluationAtom
  );

  const [highestLevel, setHighestLevel] = useState(highestEducation);
  const [budgetValue, setBudgetValue] = useState();
  const [minBudgetValue, setMinBudgetValue] = useState();

  // const [error, setError] = useState(false);
  //evaluation state
  const {
    countryPreference,
    courseLevelId,
    specializationId,
    departmentIds,
  } = useRecoilValue(evaluationAtom);
  const handleLevel = (data) => {
    const { value } = data;
    setHighestLevel({
      educationLevelId: value,
    });
  };

  const handleMarks = (event) => {
    const { name, value } = event.target;

    if (name == "marksAchieved") {
      if (highestLevel.gradingSystem == "") {
        swalError("Please select greading system first");
        setHighestLevel((prev) => ({
          ...prev,
          marksAchieved: "",
        }));
        return false;
      } else if (
        (highestLevel.gradingSystem == "Grade Point (0.0 to 4.0)" ||
          highestLevel.gradingSystem == "4-Point Scale (0 to 4)") &&
        parseFloat(value) > 4
      ) {
        swalError(`Sorry You Can Input Max 0 to 4)`);
        setHighestLevel((prev) => ({
          ...prev,
          marksAchieved: "",
        }));
        return false;
      } else if (
        highestLevel.gradingSystem == "Grade Point (0.0 to 5.0)" &&
        parseFloat(value) > 5
      ) {
        swalError(`Sorry You Can Input Max 0 to 5)`);
        setHighestLevel((prev) => ({
          ...prev,
          marksAchieved: "",
        }));
        return false;
      } else if (
        highestLevel.gradingSystem == "Grade Point (0.0 to 10.0)" &&
        parseFloat(value) > 10
      ) {
        swalError(`Sorry You Can Input Max 0.0 to 10)`);
        setHighestLevel((prev) => ({
          ...prev,
          marksAchieved: "",
        }));
        return false;
      } else if (
        (highestLevel.gradingSystem == "Grade Point (0 to 100)" ||
          highestLevel.gradingSystem == "Percentage (0 - 100%)") &&
        parseFloat(value) > 100
      ) {
        swalError(`Sorry You Can Input Max 0.0 to 100)`);
        setHighestLevel((prev) => ({
          ...prev,
          marksAchieved: "",
        }));
        return false;
      }
    }
    setHighestLevel((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleBudget = (event) => {
    if (event.target.value < parseInt(minBudgetValue)) {
      swalError(
        `Budget must be greater than or equal to ${parseInt(minBudgetValue)}`
      );
      setHighestLevel((prev) => ({
        ...prev,
        budget: undefined,
      }));
      setBudgetValue("");
    } else {
      setHighestLevel((prev) => ({
        ...prev,
        budget: event.target.value,
      }));
    }
  };

  const currentlyPursing = (e) => {
    const { checked } = e.target;
    setHighestLevel((prev) => ({
      ...prev,
      currentlyPursue: checked,
      endDate: "",
      expectedEndDate: "",
      marksAchieved: "",
      gradingSystem: "",
    }));
  };

  //update Highest Level Education
  useEffect(() => {
    setHighestEducation((prev) => ({
      ...prev,
      highestEducation: highestLevel,
    }));
  }, [highestLevel]);

  const minimunBudget = () => {
    API.post("public/university-course/minimum-budget", {
      countryPreference: countryPreference,
      courseLevelId: courseLevelId,
      specializationId: specializationId,
      departmentIds: departmentIds,
    }).then((res) => {
      setMinBudgetValue(res.data);
    });
  };

  useEffect(() => {
    minimunBudget();
  }, [countryPreference, courseLevelId, specializationId, departmentIds]);
  //handle next button
  useEffect(() => {
    if (highestEducation.educationLevelId && highestEducation.startDate) {
      if (
        highestEducation.currentlyPursue &&
        highestEducation.expectedEndDate &&
        highestEducation.budget &&
        highestEducation.expectedEndDate != ""
      ) {
        setHighestEducation((prev) => ({
          ...prev,
          show_next: true,
        }));
      } else if (
        highestEducation.endDate &&
        highestEducation.gradingSystem &&
        highestEducation.marksAchieved &&
        highestEducation.budget
      ) {
        setHighestEducation((prev) => ({
          ...prev,
          show_next: true,
        }));
      } else {
        setHighestEducation((prev) => ({
          ...prev,
          show_next: false,
        }));
      }
    } else {
      setHighestEducation((prev) => ({
        ...prev,
        show_next: false,
      }));
    }
  }, [highestEducation]);
  const graddingOPtions = [
    {
      value: "Percentage (0 - 100%)",
      label: "Percentage (0 - 100%)",
    },
    {
      value: "Grade (A to F)",
      label: "Grade (A to F)",
    },
    {
      value: "Grade Point (0.0 to 4.0)",
      label: "Grade Point (0.0 to 4.0)",
    },
    {
      value: "Grade Point (0 to 100)",
      label: "Grade (0 to 100)",
    },
    {
      value: "Grade Point (0.0 to 5.0)",
      label: "Grade Point (0.0 to 5.0)",
    },
    {
      value: "Grade Point (0.0 to 10.0)",
      label: "Grade Point (0.0 to 10.0)",
    },
    {
      value: "4-Point Scale (0 to 4)",
      label: "4-Point Scale (0 to 4)",
    },
    {
      value: "Class/Division",
      label: "Class/Division",
    },
    { value: "Other", label: "Other" },
  ];

  const afGradding = [
    {
      label: "A",
      value: "A",
    },
    {
      label: "B",
      value: "B",
    },
    {
      label: "C",
      value: "C",
    },
    {
      label: "D",
      value: "D",
    },
    {
      label: "E",
      value: "E",
    },
    {
      label: "F",
      value: "F",
    },
  ];

  const classOptions = [
    {
      label: "First-Class Honours (1st)",
      value: "First-Class Honours (1st)",
    },
    {
      label: "Upper Second-Class Honours (2:1)",
      value: "Upper Second-Class Honours (2:1)",
    },
    {
      label: "Lower Second-Class Honours (2:2)",
      value: "Lower Second-Class Honours (2:2)",
    },
    {
      label: "Third-Class Honours (3rd)",
      value: "Third-Class Honours (3rd)",
    },
  ];

  return (
    <>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>
          What is Your Highest Education Level?
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.eduLavel}>
          <div className={styles.form_group}>
            <label>Education Level</label>
            <Select
              styles={selectStyles}
              name={`highestEducation.educationLevelId`}
              onChange={handleLevel}
              options={[
                {
                  label: "Select...",
                  value: "",
                },
                ...heightEducationLevel,
              ]}
              value={
                highestEducation && highestEducation.educationLevelId
                  ? heightEducationLevel.filter(
                      (item) => item.value == highestEducation.educationLevelId
                    )
                  : []
              }
            />
          </div>
        </div>
        <div className={styles.education_form_wrapper}>
          {highestLevel && (
            <>
              <FormControlLabel
                className="evaluation_form_label"
                control={
                  <Checkbox
                    onChange={(e) => currentlyPursing(e)}
                    checked={highestLevel?.currentlyPursue ? true : false}
                  />
                }
                label="I’m Currently Pursuing This"
              />

              <div className={styles.form_wrapper}>
                <div className={styles.form_group}>
                  <label>Start Date</label>
                  <DatePickerComponent
                    name={`startDate`}
                    selected={highestLevel?.startDate}
                    max={
                      highestLevel?.currentlyPursue
                        ? new Date()
                        : moment(new Date()).subtract(2, "years")
                    }
                    onChange={handleMarks}
                  />
                </div>

                {highestLevel && highestLevel?.currentlyPursue && (
                  <div className={styles.form_group}>
                    <label htmlFor="">Expected End Date</label>
                    <DatePickerComponent
                      name={`expectedEndDate`}
                      selected={highestLevel?.expectedEndDate}
                      min={moment(highestLevel?.startDate ?? new Date()).add(
                        2,
                        "years"
                      )}
                      onChange={handleMarks}
                    />
                  </div>
                )}

                {highestLevel?.currentlyPursue != true && (
                  <div className={styles.form_group}>
                    <label htmlFor="">End Date</label>
                    <DatePickerComponent
                      name={`endDate`}
                      selected={highestLevel?.endDate}
                      onChange={handleMarks}
                      min={highestLevel?.startDate}
                      max={new Date()}
                    />
                  </div>
                )}

                {highestLevel?.currentlyPursue != true && (
                  <div
                    className={`${styles.form_group} ${styles.span_two_mobile}`}
                  >
                    <label htmlFor="">Grading System</label>
                    <Select
                      name={`gradingSystem`}
                      styles={selectStyles}
                      onChange={(data) => {
                        let target = {
                          name: "gradingSystem",
                          value: data.value,
                        };
                        handleMarks({
                          target,
                        });

                        //mark achieve remove
                        setHighestLevel((prev) => ({
                          ...prev,
                          marksAchieved: "",
                        }));
                      }}
                      options={graddingOPtions}
                      value={
                        highestLevel.gradingSystem &&
                        graddingOPtions.filter(
                          (item) => item.value == highestLevel.gradingSystem
                        )
                      }
                    />
                  </div>
                )}

                {highestLevel.gradingSystem &&
                  (highestLevel.gradingSystem == "Grade Point (0 to 100)" ||
                    highestLevel.gradingSystem == "Grade Point (0.0 to 4.0)" ||
                    highestLevel.gradingSystem == "Grade Point (0.0 to 5.0)" ||
                    highestLevel.gradingSystem == "Grade Point (0.0 to 10.0)" ||
                    highestLevel.gradingSystem == "4-Point Scale (0 to 4)" ||
                    highestLevel.gradingSystem == "Percentage (0 - 100%)") && (
                    <div
                      className={`${styles.form_group} ${styles.span_two_mobile}`}
                    >
                      <label htmlFor="">Achieved or Expected Marks</label>
                      <input
                        type="number"
                        name={`marksAchieved`}
                        placeholder="Achieved or Expected Marks"
                        onChange={handleMarks}
                        value={highestLevel.marksAchieved ?? ""}
                      />
                    </div>
                  )}

                {highestLevel.gradingSystem &&
                  highestLevel.gradingSystem == "Other" && (
                    <div
                      className={`${styles.form_group} ${styles.span_two_mobile}`}
                    >
                      <label htmlFor="">
                        Achieved or Expected Marks(Other)
                      </label>
                      <input
                        type="text"
                        name={`marksAchieved`}
                        placeholder="Achieved or Expected Marks(Other)"
                        onChange={handleMarks}
                        value={highestLevel.marksAchieved ?? ""}
                      />
                    </div>
                  )}

                {highestLevel.gradingSystem &&
                  highestLevel.gradingSystem == "Grade (A to F)" && (
                    <div
                      className={`${styles.form_group} ${styles.span_two_mobile}`}
                    >
                      <label htmlFor="">Achieved or Expected Marks</label>
                      <Select
                        name={`marksAchieved`}
                        styles={selectStyles}
                        onChange={(data) => {
                          let target = {
                            name: "marksAchieved",
                            value: data.value,
                          };
                          handleMarks({
                            target,
                          });
                        }}
                        options={afGradding}
                        value={
                          highestLevel.marksAchieved &&
                          afGradding.filter(
                            (item) => item.value == highestLevel.marksAchieved
                          )
                        }
                      />
                    </div>
                  )}

                {highestLevel.gradingSystem &&
                  highestLevel.gradingSystem == "Class/Division" && (
                    <div
                      className={`${styles.form_group} ${styles.span_two_mobile}`}
                    >
                      <label htmlFor="">Achieved or Expected Marks</label>
                      <Select
                        name={`marksAchieved`}
                        styles={selectStyles}
                        onChange={(data) => {
                          let target = {
                            name: "marksAchieved",
                            value: data.value,
                          };
                          handleMarks({
                            target,
                          });
                        }}
                        options={classOptions}
                        value={
                          highestLevel.marksAchieved &&
                          classOptions.filter(
                            (item) => item.value == highestLevel.marksAchieved
                          )
                        }
                      />
                    </div>
                  )}
              </div>
            </>
          )}
        </div>

        <div className={styles.title_wrapper}>
          <div className={styles.title}>Budget (in USD)</div>
        </div>
        <div className={styles.eduLavel}>
          <div className={styles.budget_input}>
            <input
              onBlur={(event) => {
                if (event.target.value) handleBudget(event);
              }}
              onChange={(e) => {
                setBudgetValue(e.target.value);
                setHighestLevel((prev) => ({
                  ...prev,
                  budget: e.target.value,
                }));
              }}
              type="number"
              name="point"
              placeholder="Budget"
              value={budgetValue}
            />
            {minBudgetValue && (
              <div className={styles.budget_alert}>
                Minimum budget <span className="fw600">${minBudgetValue}</span>{" "}
                <br />
                according to your given data
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EvaluationEducation;
